<div class="tab-pane" role="tabpanel" id="Mod_parcial">
    <fieldset id="agregar_mod" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <div class="form-horizontal">
                            <h3 class="form-signin-heading"><strong>Modificaci&oacute;n parcial</strong></h3>
                            <div class="form-group col-md-12">   
                                <label for="supt_parcial" class="col-md-3" style="padding-top: 22px">Superficie total de terreno</label>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="m2" id="supt_parcial" name="supt_parcial" formControlName="supt_parcial" (change)="add_mod_parcial()" >
                                    </mat-form-field>
                                </div>
                                <label for="supm_parcial" class="col-md-3"  style="padding-top: 22px">Superficie que se modifica</label>
                                <div class="col-md-3">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="m2" id="supm_parcial" name="supm_parcial" formControlName="supm_parcial" (change)="add_mod_parcial()" >
                                    </mat-form-field>
                                </div>
                            </div>
                           
                            
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>